var map = {
	"./birdSideeye.png": 4841,
	"./birds.png": 5530,
	"./class-of-2020.png": 6201,
	"./facebook.png": 1360,
	"./instagram.png": 9050,
	"./logo.png": 6533,
	"./merl-bird.png": 8710,
	"./merl-top-10.png": 8182,
	"./notfound-bird.png": 3689,
	"./score-green.png": 6834,
	"./score-orange.png": 3429,
	"./score-red.png": 6246,
	"./score-yellow.png": 4435,
	"./spiderverse.png": 8076,
	"./topstudios.png": 7834,
	"./twitter.png": 8567,
	"./wandavision.png": 9533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3311;